import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {TextField} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {addBRTargetIpProvided} from "../../../actions";
import {bbShortenString} from "../../../util/bbHelpers";
import BBExternalLink from "../accents/BBExternalLink";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const {targetEntityId} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustCreateNewTargetIpProvided} = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {customerInView} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();
  
    const [ip, setIp] = useState(null);
    const [comments, setComments] = useState(null);
    const [entityId, setEntityId] = useState(targetEntityId);


    const clearForm = () => {

        setIp("");
        setComments("");
        document.getElementById('NewBRTargetIpProvidingForm').reset();
    }

  useEffect(() => {
    if(didJustCreateNewTargetIpProvided) {
        clearForm();
    }
  }, [dispatch, didJustCreateNewTargetIpProvided]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {

        dispatch(addBRTargetIpProvided({
            "ip": ip,
            "comments": comments,
            "entityId": entityId,
            customerId: customerInView,
        }));
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">
            <form id={"NewBRTargetIpProvidingForm"} className={classes.root}>

                <TextField
                    label={<IntlMessages id="appModule.newBRTargetIpProviding.ipAddress"/>}
                    // fullWidth
                    id="ip"
                    name="ip"
                    required
                    error={!!errors.ip}
                    onChange={(event) => setIp(event.target.value)}
                    defaultValue={ip}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                        // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    })}
                    helperText={(!errors.name && <>More about <BBExternalLink
                        href={`https://www.digitalocean.com/community/tutorials/understanding-ip-addresses-subnets-and-cidr-notation-for-networking`}
                        tipText={`Learn more about CIDR notation at DigitalOcean.com in a new browser tab.`}
                    >
                        {`CIDR notation.`}
                    </BBExternalLink></>) || errors.ip?.message}
                />

                <h3>Comments (optional)</h3>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.comments"/>}
                    fullWidth
                    id="comments"
                    name="comments"
                    // required
                    error={!!errors.comments}
                    onChange={(event) => setComments(event.target.value)}
                    defaultValue={comments}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    // inputRef={register({
                    //     required: "This field is required." ,
                    //     // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    // })}
                    helperText={ errors.comments?.message}
                />
                <br/>
                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.ip}
                                variant="contained" color="primary">
                            <IntlMessages id="form.submit"/>
                        </Button>
                    </div>

            </form>

        </div>
    );

}

export default Form